import RequestHandler from "./RequestHandler";

function OrganizationsAPI() {
    const baseOrganizationsAPI = "organizations";

    async function getOrganizations(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "name";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${baseOrganizationsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getOrganization() {
        try {
            const result = await RequestHandler.get(`${baseOrganizationsAPI}`);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function addNewOrganization(newOrganization) {
        try {
            const result = await RequestHandler.post(
                baseOrganizationsAPI,
                newOrganization
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateOrganization(editOrganization) {
        try {
            const result = await RequestHandler.patch(
                baseOrganizationsAPI,
                editOrganization
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteOrganization(id) {
        try {
            const result = await RequestHandler.remove(
                `${baseOrganizationsAPI}/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getOrganizationInfo() {
        try {
            const result = await RequestHandler.get(
                `${baseOrganizationsAPI}/info`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getExternalOrganizationInfo(id) {
        try {
            const result = await RequestHandler.get(
                `${baseOrganizationsAPI}/info/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateOrganizationInfo(editedInfo) {
        try {
            const result = await RequestHandler.put(
                `${baseOrganizationsAPI}/info`,
                editedInfo
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getOrganizations,
        addNewOrganization,
        updateOrganization,
        deleteOrganization,
        getOrganizationInfo,
        getExternalOrganizationInfo,
        updateOrganizationInfo,
        getOrganization,
    };
}

export default OrganizationsAPI();
